interface LogoProps {
  className?: string;
}

export default function Logo({ className = "w-10 h-10" }: LogoProps) {
  return (
    <img
      src="/logo.png"
      alt="Serra Consultoria e Tecnologia"
      className={`rounded-xl shrink-0 object-contain ${className}`}
    />
  );
}
